import React, { useState, useEffect, useContext } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import MainLoadingComponent from "components/mainLoading";
import Loadable from "react-loadable";
import SidebarComponent from "components/sidebar";
import SidebarForChannelComponent from "components/sidebar/sidebarForChannel";
import { connect } from "react-redux";
import { Map } from "immutable";
import PrivateRoute from "routes/PrivateRoute";
import { INotificationsContainerProps } from "./INotificationsContainerProps";
import store from "../../store/configureStore";
import { globalActions } from "../../store/actions";
import { setlocalStorageValue, getlocalStorageValue } from "utils/localStorage";
import { AppContext } from "containers/main/MainComponent";
import CommunitieSwitcher from "components/CommunitieSwitcher/CommunitieSwitcher";

const AsyncNotifications: any = Loadable({
  loader: () => import("containers/notifications"),
  loading: MainLoadingComponent
});

const AsyncRouterSwitch: any = Loadable({
  loader: () => import("containers/routerSwitch"),
  loading: MainLoadingComponent
});

const NotificationsContainer: React.FC<INotificationsContainerProps> = props => {
  const [isSideBar, setIsSideBar] = useState<any>("");
  const [sideBarIsOpen, setSideBarIsOpen] = useState<string>("");

  const { isAuthed, global, subdomain, group } = props;

  useEffect(() => {
    if (window.innerWidth < 992) {
      setlocalStorageValue("sidebar", false);
    }

    if (window.innerWidth > 992) {
      setSideBarIsOpen("sidebar-is-open");
    }
  }, [props.location.pathname]);

  useEffect(() => {
    store.store.dispatch(globalActions.setSelectedGroup(group));
  }, [group])

  useEffect(() => {
    if (getlocalStorageValue("sidebar") && getlocalStorageValue("sidebar").value) {
      setSideBarIsOpen("sidebar-is-open");
    }
    setIsSideBar(getlocalStorageValue("sidebar") && getlocalStorageValue("sidebar").value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getlocalStorageValue("sidebar") && getlocalStorageValue("sidebar").value]);

    const appContext = useContext(AppContext);

  return (
    <div
      className={
        isSideBar && isAuthed ? `main-wrap ${sideBarIsOpen}` : "main-wrap"
      }
    >
      {isAuthed ? (
        <>
        <SidebarComponent subdomain={subdomain} group={group && group} />
        <CommunitieSwitcher 
          userId={props.uid}
          selectedGroup={appContext.group}
          />
        </>
      ) : (
        <SidebarForChannelComponent
          subdomain={subdomain || (global && global.currentSlug)}
        />
      )}
      <div
        className={`content-wrap flex flex-justify-center ${!isAuthed &&
          "no-auth"}`}
      >
        {!subdomain ? (
          <Switch>
            <PrivateRoute
              authed={isAuthed}
              group={group}
              exact={true}
              path={"/notifications"}
              component={<AsyncNotifications
                group={group}
                subdomain={subdomain}
                refreshNotificationsCountRef={props.refreshNotificationsCountRef}
              />}
            />
          </Switch>
        ) : (
          <Switch>
            <PrivateRoute
              authed={isAuthed}
              group={group}
              exact={true}
              path={"/notifications"}
              component={<AsyncNotifications
                group={group}
                subdomain={subdomain}
                refreshNotificationsCountRef={props.refreshNotificationsCountRef}
              />}
            />
            <Route
              render={() => {
                return (
                  <AsyncRouterSwitch
                    switchToMain={true}
                    subdomain={subdomain}
                  />
                );
              }}
            />
          </Switch>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (
  dispatch: any,
  ownProps: INotificationsContainerProps
) => {
  return {};
};

const mapStateToProps = (state: Map<string, any>) => {
  const authorize = Map(state.get("authorize", {})).toJS() as any;
  const global = Map(state.get("global", {})).toJS() as any;
  const globalUser: any = state.getIn(["authorize", "user"]);

  return {
    globalUser,
    global,
    guest: authorize.guest,
    uid: authorize.uid,
    isAuthed: authorize.authed
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NotificationsContainer as any) as any
) as any;
